import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveUser } from '../auth';

const API_URL = 'https://anees-erp-cloud.anees-erp-ahmed.workers.dev';

function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError('');

      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || data.error || 'خطأ في تسجيل الدخول');
      }

      saveUser(data.token, data.user);
      navigate('/');
    } catch (err) {
      setError(err.message || 'تعذر تسجيل الدخول');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="brand-login-page">
      <div className="brand-orb brand-orb-one" />
      <div className="brand-orb brand-orb-two" />

      <div className="brand-login-shell">
        <section className="brand-login-hero">
          <div className="brand-logo-stack">
            <div className="brand-logo-frame brand-logo-frame-company">
              <img src="/anees-logo.jpeg" alt="شعار شركة أنيس" />
            </div>

            <div className="brand-logo-frame brand-logo-frame-system">
              <img src="/system-logo.jpeg" alt="شعار النظام" />
            </div>
          </div>

          <div className="brand-login-title">
            <p className="brand-pill">شركة أنيس × الإشارة التقنية</p>
            <h1>نظام الإشارة الإداري</h1>
            <p>
              منصة موحدة لإدارة المحافظ، المحلات، العمليات المالية، التقارير، والتنبيهات اليومية.
            </p>
          </div>

          <div className="brand-login-features">
            <span>محافظ</span>
            <span>محلات</span>
            <span>تقارير</span>
            <span>تنبيهات</span>
          </div>
        </section>

        <section className="brand-login-card">
          <div className="brand-login-card-header">
            <img src="/anees-logo.jpeg" alt="أنيس" />
            <div>
              <h2>تسجيل الدخول</h2>
              <p>أدخل بياناتك للمتابعة للنظام</p>
            </div>
          </div>

          {error && (
            <div className="brand-alert-error">
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="brand-login-form">
            <label>
              <span>اسم المستخدم</span>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="مثال: أحمد "
                autoComplete="username"
              />
            </label>

            <label>
              <span>كلمة المرور</span>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="كلمة المرور"
                autoComplete="current-password"
              />
            </label>

            <button type="submit" disabled={loading}>
              {loading ? 'جاري الدخول...' : 'دخول للنظام'}
            </button>
          </form>

          <div className="brand-login-footer">
            <img src="/system-logo.jpeg" alt="الإشارة التقنية" />
            <span>واجهة رسمية محمية لفريق العمل</span>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Login;
